export default __webpack_public_path__ + "static/media/Footpad's Armbands of the Burning Temple.62b22910.jpg";